export const strings = {
    en: {
      address: 'Address',
    },
    de: {
      address: 'Adresse',
    },
  };